module.exports = __webpack_public_path__ + "img/bg_contact.28e7c465.png";